export const isFailure = (e) => {
    return e.error !== undefined;
};
export const isSuccess = (e) => {
    return e.result !== undefined;
};
export const failure = (error) => ({ error });
export const success = (result) => ({ result });
//# sourceMappingURL=either.js.map